import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TaskService } from '../../../../services';
import { JobScreenFuelLevelsTask } from '../../../../interfaces/screen-specific/job-screen';
import { IFuelReading } from '../../../../interfaces/fuel-reading';
import { Message } from '../../../../classes/Message';
import { MessageService } from 'primeng';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OrganisationTypeEnum } from '../../../../enums/organisation-types';
import { FuelLevelService } from 'src/app/services/fuel-level.service';

@Component({
  selector: 'job-screen-fuel-levels',
  templateUrl: './job-screen-fuel-levels.component.html',
  styleUrls: ['./job-screen-fuel-levels.component.scss'],
})
export class JobScreenFuelLevelsComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() organisationTypeId: number;
  @Input() fuelLevelTask: JobScreenFuelLevelsTask;

  fuelLevelsSelectItems: { label: string; value: number }[] = [];
  fuelForm: FormGroup;
  awaitingAllocation = false;

  protected readonly OrganisationTypeEnum = OrganisationTypeEnum;

  constructor(
    public fb: FormBuilder,
    public taskService: TaskService,
    private messageService: MessageService,
    private fuelLevelService: FuelLevelService,
  ) {
    this.fuelForm = this.fb.group({
      pickupFuel: new FormControl(1000, [Validators.required, Validators.min(0)]),
      dropoffFuel: new FormControl(1000, [Validators.required, Validators.min(0)]),
    });
  }

  async ngOnInit() {
    await this.initFuelLevels();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.fuelLevelTask) {
      this.awaitingAllocation = this.fuelLevelTask.driverId == null;
      this.fuelForm.patchValue({
        pickupFuel: this.fuelLevelTask.pickupFuel,
        dropoffFuel: this.fuelLevelTask.dropoffFuel,
      });
    }
  }

  async ngAfterViewInit() {}

  private async initFuelLevels() {
    this.fuelLevelsSelectItems = [{ value: 0, label: '' }];
    const fuelLevels = await this.fuelLevelService.getFuelLevels();
    fuelLevels.forEach((x) => {
      this.fuelLevelsSelectItems.push({ label: x.fuelLevelName, value: +x.fuelLevel });
    });
    this.fuelForm.patchValue({
      pickupFuel: this.fuelLevelTask.pickupFuel,
      dropoffFuel: this.fuelLevelTask.dropoffFuel,
    });
  }

  getFuelLevel(fuel: number) {
    const fuelLevel = this.fuelLevelsSelectItems.find((x) => x.value == fuel);
    return fuelLevel?.label;
  }

  saveFuelReadings() {
    this.saveFuelReading(true).then(() => {
      this.saveFuelReading(false).then(() => {
        this.messageService.add(Message.Success('Fuel readings saved'));
      });
    });
    this.fuelForm.markAsPristine();
  }

  saveFuelReading(isPickup: boolean) {
    let editedFuel: IFuelReading = {
      taskId: this.fuelLevelTask.id,
      isPickup: isPickup,
      fuel: isPickup ? this.fuelForm.value.pickupFuel : this.fuelForm.value.dropoffFuel,
    };

    return this.taskService.saveFuelReading(editedFuel).catch(() => {
      this.messageService.add(
        Message.Error(
          'An error occurred while changing fuel reading. Try again.',
          'Change Fuel Reading',
        ),
      );
    });
  }
}
